import {Fragment} from "react";
import PersonForm from "../../../../component/PersonForm/PersonForm";
import StaticLoginForm from "../../../../component/StaticLoginForm/StaticLoginForm";
import AddressForm from "../../../../component/AddressForm/AddressForm";
import Select from "../../../../component/Select/Select";
import ExceptionGoodForm from "../../../../component/ExceptionGoodForm/ExceptionGoodForm";
import AreaBlockTreeSelect from "../../../Towns/component/AreaBlockTreeSelect/AreaBlockTreeSelect";

const DriverForm = ({driver , onChange}) => {
    const area = {
        isAllIsland: "FALSE",
        includeAreaBlock: [],
        excludeAreaBlock: [],
        includeTown :[],
        excludeTown: [],
    }

    const changeDriver = (key, value) => {
        const newDriver = {...driver, [key]: value}
        onChange(newDriver);
    }

    return (
        <Fragment>
            <PersonForm person={driver.person} onChange={(value) => {
                changeDriver("person" , value);
            }} />

            <div className="card">
                <div className="card-body">
                    <label className="card-title mb-2">انتخاب محدوده سرویس دهی</label>
                    <AreaBlockTreeSelect selectedArea={driver.area} onChange={(value) => {
                        const newArea = {...area};
                        for (let j = 0; j < value.length; j++) {
                            if (value[j] == "ALL_ISLAND") {
                                newArea.isAllIsland = "TRUE";
                                newArea.includeAreaBlock = [];
                                newArea.excludeAreaBlock = [];
                                newArea.includeTown = [];
                                newArea.excludeTown = [];
                            } else if (isNaN(value[j])) {
                                //area block
                                newArea.isAllIsland = "FALSE";
                                newArea.includeAreaBlock = [...newArea.includeAreaBlock, value[j]];
                            } else {
                                // town
                                newArea.isAllIsland = "FALSE";
                                newArea.includeTown = [...newArea.includeTown, value[j]];
                            }
                        }
                        changeDriver("area" , newArea);
                    }}/>
                </div>
            </div>
        </Fragment>
    );
}

export default DriverForm;